<template>
  <div class="standing">
    <div class="operation-bar">
      <!-- search -->
      <search
        @getDepartList="getDepartList"
      ></search>
      <el-row class="operation-box">
        <el-button size="small" type="default" icon="el-hg-icon-detail" @click="getDetail">详情</el-button>
        <el-button size="small" type="default" icon="el-hg-icon-add" @click="add" v-permission="'0401'">新增</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="edit" v-permission="'0402'">修改</el-button>
        <!-- <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="delItems">删除</el-button> -->
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh">刷新</el-button>
        <el-button size="small" type="success" icon="el-hg-icon-start" @click="startUse" v-permission="'0404'">启用</el-button>
        <el-button size="small" type="warning" icon="el-hg-icon-stop" @click="stopUse" v-permission="'0405'">停用</el-button>
      </el-row>
    </div>
    <!-- list view -->
    <list @handleCheckChange="handleCheckChange" :name="queryParams.name" ref="treeList" v-if="isRefresh"/>
    <add :show="bAddShow" @close="bAddShow = false" @addKeyChildren="addKeyChildren"/>
    <edit-dialog :data="oActiveItem"
                 :show="bShowEditDialog"
                 :title.sync="title"
                 :is-edit.sync="isEdit"
                 @close="bShowEditDialog = false"
                 @updateKeyChildren="updateKeyChildren"/>
  </div>
</template>
<script>
import search from './search';
import list from './list';
import add from './actions/add';
import editDialog from './actions/edit';

export default {
  name: 'organizationalManagement',
  components: {
    search,
    list,
    add,
    editDialog
  },
  data() {
    return {
      queryParams: {
        name: '',
        depCode: '330000000000'
      },
      aData: {},
      total: 0,
      title: '',
      isEdit: false,
      bAddShow: false,
      selectArr: [],
      oActiveItem: {
        id: '',
        parentId: '',
        departId: '',
        name: '',
        shortname: '',
        phone1: '',
        grade: '',
        phone2: '',
        sort: '',
        select: ''
      },
      bShowEditDialog: false,
      isRefresh: true
    };
  },
  methods: {
    handleCheckChange(selectArr) {
      this.selectArr = selectArr;
    },
    delItems() {
      this.deleteSystem();
    },
    async deleteSystem() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一个资源');
        return;
      }
      this.$confirm(`此操作将永久删除资源<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$services.postLoading({
          type: 'RESOURCEMANGEMENT',
          url: 'deleteResource',
          params: { ids: JSON.stringify(this.selected.ids) }
        }).then(res => {
          if (res.code === '000') {
            this.$toaster.ok('删除成功');
            this.refresh();
          }
          else {
            this.$toaster.error(res.msg);
          }
        });
      }).catch(() => {
      });
    },
    edit() {
      if (this.selectArr.length === 0) {
        this.$toaster.error('请选择一个机构');
        return;
      }
      this.title = '机构编辑';
      this.isEdit = true;
      this.getDepartDetail();
    },
    getDetail() {
      if (this.selectArr.length === 0) {
        this.$toaster.error('请选择一个机构');
        return;
      }
      this.title = '机构详情';
      this.isEdit = false;
      this.getDepartDetail();
    },
    async getDepartDetail() {
      let _this = this;
      const res = await this.$services.post({
        type: 'ORGANIZATIONALMANAGEMENT',
        url: 'getDepartDetail',
        params: {
          depCode: _this.selectArr[0].depCode
        }
      });
      if (res.code === '000') {
        this.oActiveItem = res.bean;
        if (res.bean.parentId) {
          this.oActiveItem.selectedArr = res.bean.parentId.split(',');
        }
        else {
          this.oActiveItem.selectedArr = [];
        }
        this.bShowEditDialog = true;
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    add() {
      this.bAddShow = true;
    },
    async getDepartList(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
    },
    refresh() {
      setTimeout(() => {
        this.isRefresh = true;
      }, 200);
      this.getDepartList();
      this.$refs.treeList.refresh();
    },
    async updateDepartStatus(state) {
      // state 0：停用，1：启用
      let selected = this.getCheckItems();
      const res = await this.$services.postLoading({
        type: 'ORGANIZATIONALMANAGEMENT',
        url: 'updateDepartStatus',
        params: {
          depCodes: JSON.stringify(selected.depCodes),
          state
        }
      });
      if (res.code === '000') {
        this.$message({
          type: 'success',
          message: state === 0 ? '停用成功' : '启用成功'
        });
        this.updateKeyChildren('state', state);
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: state === 0 ? '停用失败' : '启用失败'
        });
      }
    },
    startUse() {
      let selected = this.getCheckItems();
      if (selected.depCodes.length === 0) {
        this.$toaster.error('请选择至少一机构');
        return;
      }
      this.$confirm(`此操作将启用<span style="color:red;padding:0 4px;"> ${selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateDepartStatus(1);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启用'
        });
      });
    },
    stopUse() {
      let selected = this.getCheckItems();
      if (selected.depCodes.length === 0) {
        this.$toaster.error('请选择至少一机构');
        return;
      }
      this.$confirm(`此操作将停用<span style="color:red;padding:0 4px;"> ${selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateDepartStatus(0);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停用'
        });
      });
    },
    addKeyChildren() { // 新增机构
      this.isRefresh = false;
      this.refresh();
    },
    updateKeyChildren(type, state) { // 更新机构
      let selectArr = this.getCheckItems();
      if (type === 'state') {
        this.selectArr.forEach((i, index) => {
          let item = this.selectArr[index];
          item.state = state;
          this.$refs.treeList.updateKeyChildren(selectArr.depCodes[index], this.selectArr[index]);
        });
      }
      else {
        this.isRefresh = false;
        this.refresh();
      }
    },
    getCheckItems() {
      let depCodes = [];
      let textInfo = [];
      this.selectArr.forEach(data => {
        depCodes.push({
          value: data.depCode
        });
        textInfo.push(data.name);
      });
      return {
        textInfo,
        depCodes
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.pagination-box {
  text-align: center;
}

/*.operation-box{*/
/*padding:10px;*/
/*background: #F1F9FB;*/
/*}*/
</style>
